import { useQuery } from '@tanstack/react-query';
import { ClientError, type TypedDocumentString } from 'graphql-request';
import { GraphQLRequestError } from '~/lib/GraphQLRequestError.ts';
import { graphqlRequest } from '~/lib/graphql-client';

export function useGraphqlQuery<T, V = object>(
  query: TypedDocumentString<T, V>,
  queryKey: string[],
  params?: V
) {
  return useQuery({
    queryKey,
    queryFn: async () => {
      try {
        return await graphqlRequest(query, params as object);
      } catch (error) {
        if (error instanceof ClientError) {
          if (error.response.status === 401 || error.response.status === 403) {
            throw error;
          }

          if (error.response.errors) {
            throw new GraphQLRequestError(error.response.errors);
          }
        }

        // Network / unexpected error → rethrow
        throw error;
      }
    },
    retry: (failureCount, error) => {
      if (error instanceof ClientError) {
        const status = error.response.status;
        if (status === 401 || status === 403) return false;
      }
      return failureCount < 2;
    },

    staleTime: 30_000,
    refetchOnWindowFocus: false,
  });
}
